import {Box, Container, Link, Typography, useMediaQuery, useTheme} from "@mui/material";
import React from "react";
import TopBar from "../../../Components/TopBar/TopBar";
import Footer from "../../../Components/Footer/Footer";
import {useNavigate} from "react-router-dom";
import {useAlert} from "../../../Components/Providers/Alert/Alert.provider";


const ContactsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box>
      <TopBar title="Rumors Research"/>
      <Container maxWidth="md" sx={{
        mt: isMobile ? 15 : 20,
        mb: isMobile ? 15 : 25
      }}>
        <Typography variant="h4" color="primary" gutterBottom>
          Contact Us
        </Typography>
        <Box mb={4}>
          <Typography variant="h6" gutterBottom>
            About Us
          </Typography>
          <Typography>
            We are the AI and Machine Learning research group at Roma Tre University, Computer Engineering Department. Our
            goal is to advance knowledge and foster innovation in the fields of Artificial Intelligence and Machine
            Learning.
          </Typography>
        </Box>

        <Box>
  <Typography variant="h6" gutterBottom>
    Contact Information
  </Typography>
  <ul>
    <li>
      <Typography variant="body1">
        <strong>Alessio Ferrato</strong> - <Link href="mailto:alessio.ferrato@uniroma3.it">alessio.ferrato@uniroma3.it</Link>
      </Typography>
    </li>
    <li>
      <Typography variant="body1">
        <strong>Marco Napoleone</strong> - <Link href="mailto:mar.napoleone3@stud.uniroma3.it">mar.napoleone3@stud.uniroma3.it</Link>
      </Typography>
    </li>
    <li>
      <Typography variant="body1">
        <strong>Giorgio Biancini</strong> - <Link href="mailto:gio.biancini@stud.uniroma3.it">gio.biancini@stud.uniroma3.it</Link>
      </Typography>
    </li>
  </ul>
</Box>
<Box mt={4} textAlign="center">
  <Typography variant="body2" color="textSecondary">
    &copy; {new Date().getFullYear()} AI and ML Research Group - Roma Tre University.
  </Typography>
</Box>
      </Container>
      <Footer/>
    </Box>
  )
}

export default ContactsPage;